import { render, staticRenderFns } from "./amazingOffersFullWidth.vue?vue&type=template&id=f7aaa95c&scoped=true&"
import script from "./amazingOffersFullWidth.vue?vue&type=script&lang=js&"
export * from "./amazingOffersFullWidth.vue?vue&type=script&lang=js&"
import style0 from "./amazingOffersFullWidth.vue?vue&type=style&index=0&id=f7aaa95c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7aaa95c",
  null
  
)

export default component.exports